import request from '../utils/request'

// 是否海典
export function getThirdPartyPlatformCode(data) {
    return request({
        url: '/patient/thirdParty/getThirdPartyPlatformCode',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 获取海典问诊列表
export function getPrePrescriptionList(data) {
    return request({
        url: '/patient/thirdParty/getPrePrescriptionList',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 删除海典问诊
export function deletePrePrescriptionById(data) {
    return request({
        url: '/patient/thirdParty/deletePrePrescriptionById',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// id获取问诊信息
export function getPrePrescriptionById(data) {
    return request({
        url: '/patient/thirdParty/getPrePrescriptionById',
        method: 'post',
        data: data
    }).then(res => res.data)
}